var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExecuteJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 0.625H6.32099H8.82754L10.6198 2.41725L12.017 3.81444V7.11111V13.5972H0.625V0.625Z",
    stroke: "#6B6B6B",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57031 10.3227C2.57031 11.3535 3.24624 11.977 4.32649 11.977C5.40673 11.977 6.05488 11.4029 6.05488 10.3566V7.39982H4.74624V10.3474C4.74624 10.6961 4.59192 10.8813 4.30488 10.8813C4.00858 10.8813 3.8234 10.6714 3.8234 10.3227H2.57031Z",
    fill: "#6B6B6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8913 10.5541C6.89747 11.4369 7.62278 11.977 8.80488 11.977C10.0209 11.977 10.7493 11.4029 10.7493 10.4399C10.7493 9.71773 10.3481 9.30723 9.48081 9.156L8.87278 9.05106C8.44686 8.97698 8.26476 8.85353 8.26476 8.64056C8.26476 8.39365 8.48698 8.23933 8.82649 8.23933C9.17525 8.23933 9.44994 8.44303 9.4592 8.71155H10.6567C10.6475 7.85661 9.89747 7.27637 8.79871 7.27637C7.68451 7.27637 6.96537 7.86279 6.96537 8.77019C6.96537 9.48933 7.40982 9.95847 8.22772 10.1004L8.81723 10.2054C9.29562 10.2918 9.46229 10.3906 9.46229 10.5974C9.46229 10.8474 9.21846 11.0109 8.85118 11.0109C8.43142 11.0109 8.14747 10.8319 8.13204 10.5541H6.8913Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecuteJs);
export default __webpack_public_path__ + "static/media/executeJs.c2b1701fb3b57e45a70276ac2a1d191f.svg";
export { ForwardRef as ReactComponent };